import React, { useState, useRef } from "react";
import AnimeCard from "./AnimeCard";
import GenresCard from "./GenresCard";
import "./Slider.css";

const Slider = ({ animes, openAuth, title }) => {
  const carousel = useRef(null);
  const [scrollX, setScrollX] = useState(0);
  const [scrollEnd, setScrollEnd] = useState(false);

  const slide = (shift) => {
    carousel.current.scrollLeft += shift;
    scrollCheck();
  };

  const scrollCheck = () => {
    setScrollX(carousel.current.scrollLeft);

    if (
      carousel.current.offsetWidth >=
      carousel.current.scrollWidth - carousel.current.scrollLeft
    ) {
      setScrollEnd(true);
    } else {
      setScrollEnd(false);
    }
  };

  return (
    <div
      onWheel={scrollCheck}
      className="carousel relative overflow-visible flex px-[2px] w-full h-[400px] md:h-[500px] scroll-smooth snap-center "
    >
      <div className="flex items-center">
        <button
          disabled={scrollX === 0}
          onClick={() => slide(-500)}
          className="hidden md:block text-yellow/60 absolute bg-black/20 left-zero z-20 top-auto hover:opacity-100 h-[250px] hover:bg-white/60 hover:text-black disabled:opacity-25 disabled:cursor-not-allowed rounded-lg"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className=" h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            width="50px"
            height="50px"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          onClick={() => slide(+500)}
          className="hidden md:block text-yellow/60 absolute bg-black/20 right-zero z-20 top-auto hover:opacity-100 h-[250px] hover:bg-white/60 hover:text-black disabled:opacity-25 disabled:cursor-not-allowed rounded-lg"
          disabled={scrollEnd}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            width="50px"
            height="50px"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>

      {animes && (
        <div
          ref={carousel}
          className=" carousel-container no-slider w-full h-[400px] md:h-[500px] flex flex-row overflow-x-scroll snap-x snap-x-mandatory items-center touch-pan-x z-0"
        >
          {animes.map((anime, index) => (
            <div key={index} className="carousel-item snap-start">
              {title === "genres" ? (
                <GenresCard
                  index={index}
                  title={anime.title}
                  image={anime.image}
                  id={anime.id}
                />
              ) : (
                <AnimeCard
                  id={anime.mal_id}
                  index={index}
                  image={anime.images.webp.image_url}
                  title={anime.title}
                  synopsis={anime.synopsis}
                  score={anime.score}
                  openAuth={openAuth}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Slider;
